import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "trackers-rating dashboard-card" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Отчеты обратной связи", -1)
const _hoisted_5 = { class: "row mt-6" }
const _hoisted_6 = { class: "row fb-analitics__colors" }
const _hoisted_7 = {
  key: 0,
  class: "fb-analitics-grid mt-3"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" Комментарии "),
  /*#__PURE__*/_createElementVNode("span", null, "Смотреть все")
], -1)
const _hoisted_9 = { class: "subtitle" }
const _hoisted_10 = { class: "fb-analitics__comment mt-4" }
const _hoisted_11 = { class: "comment__title" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "comment__text" }
const _hoisted_14 = { class: "comment__sub" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "small" }, "Отзыв по", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "team-info-drawer__header mb-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Комментарии", -1)
const _hoisted_19 = { class: "small ml-3 mt-1" }
const _hoisted_20 = { class: "fb-analitics__comment mb-4 mx-5" }
const _hoisted_21 = { class: "comment__title" }
const _hoisted_22 = { class: "name" }
const _hoisted_23 = { class: "comment__text" }
const _hoisted_24 = { class: "comment__sub" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "small" }, "Отзыв по", -1)

import { feedbackApi } from '@/api/feedback';
import { computed, reactive, ref, shallowReactive, watch } from 'vue';
import { capitalize, num } from '@/utils/lang';
import { useDialogStore } from '@/stores/dialogs';
import { useProgramsStore } from '@/stores/programs';
import { useTrackersStore } from '@/stores/trackers';
import { useAccountStore } from '@/stores/account';
import FeedbackReportHistory from '@/components/dialogs/FeedbackReportHistory.vue'
import VBarChart from '@/components/VBarChart.vue';
import VUserInfo from '@/components/VUserInfo.vue';
import VTime from '@/components/VTime.vue';
import VStub from '@/components/VStub.vue';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'Feedbacks',
  setup(__props) {

const programsStore = useProgramsStore()
const trackersStore = useTrackersStore()
const dialogStore = useDialogStore()
const accountStore = useAccountStore()

const filter = reactive<{ 
  programId?: string, 
  teamId?: string, 
  trackerId?: string, 
  period?: string, 
  comparsion?: string, 
  pollId?: string 
}>({ teamId: "all", trackerId: "all", pollId: "all"})
const statsData = shallowReactive<{ [ programId: string ]: any[] }>({})
const pollsData = shallowReactive<{ [ programId: string ]: any[] }>({})

const program = computed(() => {
  if (!filter.programId) return null
  return programsStore.programs.find(item => item.id === filter.programId)
})

if (!accountStore.isDirector) {
  filter.trackerId = accountStore.currentUser!.id
}

watch(() => programsStore.programs.length, () => {
  if (programsStore.programs.length === 0) return
  filter.programId = programsStore.programs[0]?.id
}, { immediate: true })

watch(() => filter.programId, async (programId) => {
  filter.teamId = "all"
  filter.trackerId = "all"
  if (!accountStore.isDirector) {
    filter.trackerId = accountStore.currentUser!.id
  }
  if (!programId) return
  if (!statsData[programId]) {
    const resp = await feedbackApi.getFeedbackData(programId)
    statsData[programId] = resp.items
    pollsData[programId] = resp.polls
    for(let item of resp.polls) {
      item.name = capitalize(dayjs(item.date).format("MMMM"))
    }
  }
}, { immediate: true })
watch(() => filter.teamId, (teamId) => {
  if (teamId === "all") return
  filter.trackerId = "all"
  const team = program.value?.teams.find(item => item.id === filter.teamId) 
  if (!team) return
  filter.trackerId = team.trackerId || undefined
})

const teams = computed(() => {
  const program = programsStore.programs.find(item => item.id === filter.programId)
  if (!program) return []
  return [ { id: "all", name: "Все команды" }, ...program.teams ]
})

const trackers = computed(() => {
  if (!program.value) return []
  if (filter.teamId === "all") {
    const set = new Set()
    for (let team of program.value.teams) {
      set.add(trackersStore.trackers[team.trackerId])
    }
    return [ { id: "all", name: "Все трекеры" }, ...set.values()]
  }
  const team = program.value.teams.find(item => item.id === filter.teamId) 
  if (!team) return []
  return [ trackersStore.trackers[team.trackerId] ]
})

const filteredTeams = computed(() => {
  if (!filter.trackerId) return []
  if (filter.teamId && filter.teamId !== "all") return []
  const program = programsStore.programs.find(item => item.id === filter.programId)
  if (!program) return []

  const teams = filter.programId && new Set(statsData[filter.programId].map(item => item.teamId))

  return program.teams
    .filter(team => team.trackerId === filter.trackerId)
    .filter(team => teams && teams.has(team.id) )
})

const polls = computed(() => {
  const programId = filter.programId
  if (!programId || !pollsData[programId]) return [ { id: "all", name: "Все периоды" } ]
  return [ { id: "all", name: "Все периоды" }, ...pollsData[programId]]
})

const stats = computed<{ 
  stats: { [key: string]: any }, 
  comments: { teamId: string, trackerId: string, text: string, date: string }[],
  lastComment: { teamId: string, trackerId: string, text: string, date: string } | null
}>(() => {
  const stats = filter.programId && statsData[filter.programId]
  if (!stats) return { stats: {}, comments: [], lastComment: null }
  const comments = []
  const stat: any = {}

  for (let report of stats) {
    if (filter.trackerId && filter.trackerId !== "all" && report.trackerId !== filter.trackerId) continue
    if (filter.teamId && filter.teamId !== "all" && filter.teamId !== report.teamId) continue
    if (filter.pollId && filter.pollId !== "all" && filter.pollId !== report.feedbackPollId) continue
    for (let field in report.fields) {
      if (field.startsWith("Комментарий")) {
        if (report.fields[field]) {
          comments.push({ teamId: report.teamId, trackerId: report.trackerId, text: report.fields[field], date: report.date })
        }
        continue
      }
      if (filter.comparsion === "Сравнить по командам" && filteredTeams.value.length > 1) {
        if (!stat[field]) stat[field] = { 
          1: filteredTeams.value.map(() => 0), 
          2: filteredTeams.value.map(() => 0), 
          3: filteredTeams.value.map(() => 0), 
          4: filteredTeams.value.map(() => 0), 
          5: filteredTeams.value.map(() => 0) 
        }
        const index = filteredTeams.value.findIndex(team => team.id === report.teamId)
        stat[field][report.fields[field]][index]++
      } else if (filter.comparsion === 'Сравнить по периодам' && polls.value.length > 1) {
        if (!stat[field]) stat[field] = { 
          1: polls.value.map(() => 0), 
          2: polls.value.map(() => 0), 
          3: polls.value.map(() => 0), 
          4: polls.value.map(() => 0), 
          5: polls.value.map(() => 0) 
        }
        const index = polls.value.findIndex(polls => polls.id === report.feedbackPollId)
        stat[field][report.fields[field]][index]++
      } else {
        if (!stat[field]) stat[field] = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }
        stat[field][report.fields[field]]++
      }
    }
  }
  const lastComment = comments[0]
  return { stats: stat, comments, lastComment }
})

const colors = [
  { color: "#EF7575", title: "Абсолютно не соответствует",  },
  { color: "#EFC675", title: "По большей части не соответствует" },
  { color: "#EFEA75", title: "По большей части соответствует" },
  { color: "#C8EF75", title: "Скорее соответствует" },
  { color: "#6CCB86", title: "Полностью соответствует" }
]

const drawerOpened = ref(false)

const getTooltipStr= (value: number, count: number, index?: number) => {
  if (typeof index !== "number") {
    return `${num(value, 'человек', 'человека', 'человек')} (${Math.round(value/count*100)}%)`
  }
  if (filter.comparsion === 'Сравнить по периодам') {
    return `${polls.value[index].name}\n${num(value, 'человек', 'человека', 'человек')} (${Math.round(value/count*100)}%)`
  }
  return `${filteredTeams.value[index].name}\n${num(value, 'человек', 'человека', 'человек')} (${Math.round(value/count*100)}%)`
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_v_btn, {
            color: "primary",
            class: "ml-auto px-6",
            "prepend-icon": "mdi-file-document",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(dialogStore).open(FeedbackReportHistory)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Отчеты")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_select, {
            modelValue: filter.programId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.programId) = $event)),
            items: _unref(programsStore).programs,
            class: "v-select-min",
            variant: "outlined",
            label: "Программа",
            "item-value": "id",
            "item-title": "name"
          }, null, 8, ["modelValue", "items"]),
          _createVNode(_component_v_select, {
            modelValue: filter.teamId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.teamId) = $event)),
            items: _unref(teams),
            class: "v-select-min",
            variant: "outlined",
            label: "Команда",
            "item-value": "id",
            "item-title": "name"
          }, null, 8, ["modelValue", "items"]),
          (_unref(accountStore).isDirector)
            ? (_openBlock(), _createBlock(_component_v_select, {
                key: 0,
                modelValue: filter.trackerId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.trackerId) = $event)),
                items: _unref(trackers),
                class: "v-select-min",
                variant: "outlined",
                label: "Трекер",
                "item-value": "id",
                "item-title": "name"
              }, null, 8, ["modelValue", "items"]))
            : _createCommentVNode("", true),
          (_unref(accountStore).isDirector)
            ? (_openBlock(), _createBlock(_component_v_select, {
                key: 1,
                modelValue: filter.pollId,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filter.pollId) = $event)),
                items: _unref(polls),
                class: "v-select-min",
                variant: "outlined",
                label: "Период",
                "item-value": "id",
                "item-title": "name"
              }, null, 8, ["modelValue", "items"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_select, {
            modelValue: filter.comparsion,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filter.comparsion) = $event)),
            items: [ 'Не сравнивать', 'Сравнить по командам', 'Сравнить по периодам' ],
            class: "v-select-min",
            variant: "outlined",
            label: "Сравнение отчетов"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colors, (item) => {
            return _createElementVNode("div", null, [
              _createElementVNode("span", {
                style: _normalizeStyle({ backgroundColor: item.color })
              }, null, 4),
              _createTextVNode(" " + _toDisplayString(item.title), 1)
            ])
          }), 64))
        ]),
        ((_unref(stats).comments.length > 0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats).stats, (stat, title) => {
                return (_openBlock(), _createBlock(VBarChart, {
                  data: stat,
                  title: (title as string),
                  tooltip: getTooltipStr
                }, null, 8, ["data", "title"]))
              }), 256)),
              ((_unref(stats).comments.length > 0))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fb-analitics__card",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (drawerOpened.value = true))
                  }, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(num)(_unref(stats).comments.length, "ответ", "ответа", "ответов")), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(program)?.teams.find(item => item.id === _unref(stats).lastComment?.teamId )?.name), 1),
                        _createVNode(VTime, {
                          date: _unref(stats).lastComment?.date,
                          class: "ml-auto"
                        }, null, 8, ["date"])
                      ]),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(stats).lastComment?.text), 1),
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(VUserInfo, {
                          "user-id": _unref(stats).lastComment?.trackerId
                        }, null, 8, ["user-id"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(VStub, null, {
                default: _withCtx(() => [
                  _createTextVNode("Отчетов с заданными параметрами пока ещё нет")
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: drawerOpened.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((drawerOpened).value = $event)),
      temporary: "",
      location: "right",
      class: "team-info-drawer",
      width: "600"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(num)(_unref(stats).comments.length, "ответ", "ответа", "ответов")), 1),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            variant: "flat",
            class: "ml-auto mr-n4",
            style: {"opacity":"0.6"},
            onClick: _cache[7] || (_cache[7] = ($event: any) => ((drawerOpened.value = false)))
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats).comments, (comment) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(program)?.teams.find(item => item.id === comment.teamId )?.name), 1),
              _createVNode(VTime, {
                date: comment.date,
                class: "ml-auto"
              }, null, 8, ["date"])
            ]),
            _createElementVNode("div", _hoisted_23, _toDisplayString(comment.text), 1),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(VUserInfo, {
                "user-id": comment.trackerId
              }, null, 8, ["user-id"])
            ])
          ]))
        }), 256))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})